import React, { useState } from 'react';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import { connect } from 'react-redux';
import { container } from '@Container';
import { TYPES } from '@Types';
import { BookAction } from '@Redux/actions/publication/BookAction';
import { Draggable, Droppable } from '@hello-pangea/dnd';
import SectionRowComponent from '@Components/publication/section-row/section-row.component';
import { BookSectionView } from '@Selectors/publication/book/view/book-section.view';

const getItemStyle = (isDragging: boolean, draggableStyle: any) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',

  // change background colour if dragging
  background: isDragging ? 'lightgreen' : 'grey',

  // styles we need to apply on draggables
  ...draggableStyle
});

const getListStyle = (isDraggingOver: boolean) => ({
  background: isDraggingOver ? 'lightblue' : 'lightgrey'
});

interface IBookSectionsComponentProps {
  sections: BookSectionView[]
}
const BookSectionsComponent: React.FC<Props> = ({
                                                  sections,
                                                }) => {

  const [enabled, setEnabled] = useState(false);
  React.useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true));
    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);

  if (!enabled) {
    return (<></>);
  }

  return <Droppable droppableId='droppable'>
          {(provided: any, snapshot: any) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
            >
              {sections.map((item) => (
                <Draggable key={`section-${item.id}`} draggableId={item.id} index={item.index}>
                  {(provided: any, snapshot: any) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                    >
                      <SectionRowComponent section={item} />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>;
};

const mapStateToProps = (state: AppState, ownProps: IBookSectionsComponentProps) => ({
  sections: ownProps.sections,
});

const mapDispatchToProps = (dispatch: Dispatch) => {

  const action = container.get<BookAction>(TYPES.Actions.Publication.BookAction);

  return {
    load: (id: string) => dispatch(action.fetchData({ entityId: id })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BookSectionsComponent);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps> &
  IBookSectionsComponentProps